/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@compiled/react';

/**
 * __Cross__
 *
 * A cross glyph for the loading spinner.
 */
export const Cross = (): JSX.Element => (
	<svg
		width="598"
		height="599"
		viewBox="0 0 598 599"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			data-cross-shape
			d="M211.438 0V87.6844L299.03 175.369L386.623 87.6844V0H211.438ZM386.562 598.568V510.883L298.97 423.199L211.377 510.883V598.568H386.501H386.562ZM448.485 25.6355L386.562 87.6235V211.6H510.408L572.331 149.612L448.485 25.6355ZM25.6693 149.612L87.5923 211.6H211.438V87.6235L149.515 25.6355L25.6693 149.612ZM598 211.6H510.408L422.816 299.284L510.408 386.968H598V211.66V211.6ZM572.331 448.895L510.408 386.907H386.562V510.883L448.485 572.871L572.331 448.895ZM149.515 572.871L211.438 510.883V386.907H87.5923L25.6693 448.895L149.515 572.871ZM0 386.907H87.5923L175.185 299.223L87.5923 211.539H0V386.847V386.907ZM298.97 211.6C250.611 211.6 211.377 250.875 211.377 299.284C211.377 347.693 250.611 386.968 298.97 386.968C347.328 386.968 386.562 347.693 386.562 299.284C386.562 250.875 347.328 211.6 298.97 211.6Z"
			fill="currentColor"
		/>
	</svg>
);
